module.exports = __webpack_public_path__ + "static/drive2-min-fea2e2e791ade04aab95adaf2b24ad66.png";